import React from 'react';
import omit from 'lodash/omit';
import { Icon } from '../Icon';
import constants from 'Constants';
import './styles.scss';


const BoxIcon = (props) => {
  const { set, ...otherProps } = props;
  return (
    <Icon {...otherProps} set={constants.ICON_SET_BOX} />
  );
}


BoxIcon.propTypes = omit(Icon.propTypes, 'set');
BoxIcon.defaultProps = omit(Icon.defaultProps, 'set');
export { BoxIcon };
